import React from 'react';
import './App.css';
import logo from './logo.jpg';
import knot from './img/knot.webp';
import pinecone from './img/pinecone.webp';
import bow from './img/bow.webp';
import titleArt from './img/title.webp';
import bowStar from './img/bow-star.webp';
import tinStar from './img/tin-star.webp';
import sketchTree from './img/sketch-tree.jpg';
import sketchTag from './img/sketch-tag.jpg';
import sketchCalendar from './img/sketch-calendar.jpg';
import sketchPin from './img/sketch-pin.jpg';
import sketchEnvelope from './img/sketch-envelope.jpg';

const status = 'open' //'open' | 'sold-out' | 'closed-for-season'
const year = 2026

function Card({ title, sketch, ornament = '\u2605', sprig, align = 'center', children }) {
  return (
    <div className="card">
      <div className={`paper paper-${align}${sprig ? ' has-sprig' : ''}`}>
        <img className="sketch" src={sketch} alt="" />
        <div className={`card-body align-${align}`}>
          <h1>{title}</h1>
          <Ornament symbol={ornament} />
          {children}
        </div>
      </div>
      {['tl', 'tr', 'bl', 'br'].map(corner => (
        <img key={corner} className={`knot knot-${corner}`} src={knot} alt="" />
      ))}
      {sprig && <img className={`sprig sprig-${sprig}`} src={pinecone} alt="" />}
    </div>
  )
}

function Ornament({ symbol }) {
  return (
    <div className="ornament" aria-hidden="true">
      <svg viewBox="0 0 120 12" className="arrow">
        <path d="M2 6 H112 M104 2 L114 6 L104 10 M2 6 L8 2 M2 6 L8 10 M8 6 L14 2 M8 6 L14 10" />
      </svg>
      <span>{symbol}</span>
      <svg viewBox="0 0 120 12" className="arrow arrow-flip">
        <path d="M2 6 H112 M104 2 L114 6 L104 10 M2 6 L8 2 M2 6 L8 10 M8 6 L14 2 M8 6 L14 10" />
      </svg>
    </div>
  )
}

function Divider({ side = 'right' }) {
  return (
    <div className="plaid" role="presentation">
      <img className={`bow-star bow-star-${side}`} src={bowStar} alt="" />
    </div>
  )
}

function Welcome(props) {
  return (
    <Card title="Welcome" sketch={sketchTree} ornament={'\u2665'} sprig="right">
      For over 40 years we've been providing families with the perfect Christmas tree. Riverside Acres is a family run tree farm 
      with over three acres of Christmas trees of varying size and variety.
      Bring the family out to browse our trees and cut your own tree! Fresh cut trees smell better and last longer than
      those shipped in from outside our area.
    </Card>
  )
}

function Prices(props) {
  return (
    <Card title="Prices" sketch={sketchTag}>
      We sell our trees for $12/ft up to a maximum of $75. We charge the same price regardless of variety. We hope you enjoy
      walking through the trees and picking out your favorite. For payment we accept cash or check only.
    </Card>
  )
}

function Alert(props) {
  return (
    <div className="app-alert">
      {props.children}
    </div>
  )
}

function hoursMsg(props) {
  switch (status) {
    case 'open':
      return (
        <>
          We will be open Friday Nov 27 and then Saturdays and Sundays until Christmas from 9am - 4pm (while supplies last).<br/>
          <br/><b>Our supply of mature trees is limited this year so come early for best selection</b>
        </>
      )
    case 'closed-for-season':
      return (
        <Alert>
          Attention: We are sorry to announce that we will not be selling Christmas trees in {year}. 
          We are taking this action to improve our stock of mature trees and ensure you enjoy
          future visits to our farm. 
          <br/><br/>
          We plant many new tree's each spring and expect to have an ample supply of trees 
          for sale in {year+1}. Thank you for considering us we look forward to serving you again!
        </Alert> 
      )
    case 'sold-out':
      return (
        <Alert>
        Attention: We are sorry to announce that we are "Sold Out" of trees for the {year} Season. 
        High demand and an area tree shortage quickly exceeded our supply 
        of mature trees. We have many young tree's that will mature by next year though, so we hope to 
        see you again in {year+1}. Thank you for your patronage!
      </Alert>
      )
    default:
      return <></>
  }
}

function Hours(props) {
  return (
    <Card title="Hours" sketch={sketchCalendar} sprig="left">
      {hoursMsg(props)}
    </Card>
  )
}

function Location(props) {
  return (
    <Card title="Location" sketch={sketchPin} align="left">
      The tree farm is located at:<br />
      26579 608th ST<br />
      Mantorville, MN 55955<br />
      <br />
      Find us
      <button><a target="_none" href="https://www.google.com/maps/place/26579+608th+St,+Mantorville,+MN+55955/@44.0653735,-92.6258401,12z/data=!4m2!3m1!1s0x87f76a06dfa61121:0xdac2108a189e791d">here</a></button>
      on the map or by the directions below:<br />
      <br />
      <div className="directions-heading">Directions from Rochester</div>
      <ul>
        <li>Take US Hwy 14 west to Kasson (14 miles)</li>
        <li>Take MN Hwy 57 north to Mantorville(3.1 miles)</li>
        <li>Take 5th St east to Riverside Acres (2.6 miles). Note, 5th St becomes 608th St about a mile out of town</li>
        <li>Riverside acres is the last driveway on the righthand side of the road. Look for the tree farm sign</li>
      </ul>
      <div className="directions-heading">Directions from Dodge Center</div>
      <ul>
        <li>Take US Hwy 14 east to Kasson (6.6 miles)</li>
        <li>Take MN Hwy 57 north to Mantorville(3.1 miles)</li>
        <li>Take 5th St east to Riverside Acres (2.6 miles). Note, 5th St becomes 608th St about a mile out of town</li>
        <li>Riverside acres is the last driveway on the righthand side of the road. Look for the tree farm sign</li>
      </ul>
    </Card>
  )
}

function ContactUs(props) {
  return (
    <Card title="Contact us" sketch={sketchEnvelope} sprig="right">
      You can reach us by:<br />
        {/* <!--phone: <br>--> */}
      email: <a href="mailto:info@riversideacrestreefarm.com?Subject=Tree Farm Inquiry" target="_top">info@riversideacrestreefarm.com</a> <br />
    </Card>
  )
}

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} alt="Riverside Acres Tree Farm Logo" className="header-logo" />
        <h1 className="title">
          <img src={titleArt} alt="Riverside Acres Tree Farm" />
        </h1>
        <img src={bow} alt="" className="header-bow" />
      </header>
      <nav></nav>
      <main>
        <section>
          <Welcome />
          <Divider side="right" />
          <Prices />
          <Divider side="left" />
          <Hours />
          <Divider side="right" />
          <Location />
          <Divider side="left" />
          <ContactUs/>
        </section>
      </main>
      <footer>
        <img src={tinStar} alt="" className="footer-star" />
        <div className="footer-mark" aria-hidden="true">&#9733;</div>
        <div className="footer-tagline">Family Owned &bull; Family Operated &bull; Over 40 Years</div>
        Copyright © RiversideAcresTreeFarm.com
        <img src={pinecone} alt="" className="footer-pinecone" />
      </footer>
    </div>
  );
}

export default App;
